// Dependencies
import React from "react";
import { graphql, Link } from "gatsby";
import PropTypes from "prop-types";
// Hooks
// import useMedia from "../hooks/useMedia";
// Components
import Layout from "../components/Layout";
import SplashImage from "../components/SplashImage";
// import { BackgroundImage } from "../components/Image";
import { Arrow } from "../components/Icons";

function resolveLink(link) {
  if (link.__typename === "ContentfulSiteCategory") {
    return `/${link.slug}`;
  }
  if (link.__typename === "ContentfulJournal") {
    return `/journal/${link.slug}`;
  }
  if (link.__typename === "ContentfulProject") {
    return `/project/${link.slug}`;
  }
}

function resolveColor(link) {
  if (link.__typename === "ContentfulSiteCategory") {
    return link.colorHighlight;
  }
  if (link.__typename === "ContentfulJournal") {
    return "var(--green)";
  }
  if (link.__typename === "ContentfulProject") {
    return "var(--yellow)";
  }
}

const Homepage = ({ data }) => {
  const content = data.contentfulHomepage;

  return (
    <Layout dontHideLogo hasSplash hideContactBar triggerResizeOnce>
      <div className="homepage">
        {/* Landing */}
        {/* <SplashImage
          className="homepage-section fv"
          visuals={content.heroVisuals}
          showLogo
          debug
        >
          <h1 className="h0 adjust white-overlay hero-tagline max-16em">
            {content.heroTagline.heroTagline}
          </h1>
        </SplashImage> */}

        {/* Homepage links */}
        {content.sections.map((entry) => (
          <SplashImage
            className="homepage-section fv"
            {...entry}
            key={entry.id}
            showLogo
          >
            {entry.link ? (
              <div className="align-center p3--summary text-shadow">
                <Link
                  to={resolveLink(entry.link)}
                  className="h1--homepage-section max-9em block m-auto"
                  style={{
                    color: entry.link?.colorHighlight,
                  }}
                >
                  {entry.title}
                </Link>
                <p className="outer summary m-auto">
                  <span className="text-shadow">{entry.description?.copy}</span>
                  <strong>
                    <Link
                      to={resolveLink(entry.link)}
                      className="has-arrow inlb gutters"
                      style={{ color: resolveColor(entry.link) }}
                    >
                      {` View`} <Arrow />
                    </Link>
                  </strong>
                </p>
              </div>
            ) : (
              <div className="align-center p3--summary text-shadow">
                <div className="h1--homepage-section max-9em block m-auto">
                  {entry.title}
                </div>
                <p className="outer summary m-auto">
                  <span className="text-shadow">{entry.description?.copy}</span>
                </p>
              </div>
            )}
          </SplashImage>
        ))}
      </div>
    </Layout>
  );
};

Homepage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Homepage;

export const HomepagePageQuery = graphql`
  query HomepageQuery {
    contentfulHomepage(contentful_id: { eq: "2M1hQiZq8ZUiTVV3QyFWhp" }) {
      heroVisuals {
        ...SplashImageFragment
        backgroundVideo {
          # vimeoUrl
          mp4 {
            file {
              url
            }
          }
        }
      }
      heroTagline {
        heroTagline
      }
      sections {
        id
        title
        description {
          copy: description
        }
        link {
          ... on Node {
            ... on ContentfulSiteCategory {
              __typename
              slug
              colorHighlight
            }
            ... on ContentfulJournal {
              __typename
              slug
            }
            ... on ContentfulProject {
              __typename
              slug
            }
          }
        }
        visuals {
          ...SplashImageFragment
          backgroundVideo {
            # vimeoUrl
            mp4 {
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`;
